export const teamWorkflow = {
  junior: {
    processes: [
      { name: 'Daily Standup', description: 'Share progress, blockers, and plans', time: '9:00 AM daily' },
      { name: 'Code Review Process', description: 'Submit PRs with clear descriptions', requirement: 'Minimum 1 approval required' },
      { name: 'Testing Protocol', description: 'Write unit tests for all new code', coverage: 'Minimum 80% coverage' }
    ],
    responsibilities: [
      { area: 'Feature Development', tasks: ['Implement assigned features', 'Write comprehensive tests', 'Update documentation'] },
      { area: 'Bug Fixes', tasks: ['Investigate reported issues', 'Implement fixes', 'Verify resolution'] },
      { area: 'Code Quality', tasks: ['Follow coding standards', 'Participate in code reviews', 'Refactor when needed'] }
    ],
    ceremonies: [
      { name: 'Sprint Planning', frequency: 'Bi-weekly', duration: '2 hours', role: 'Participant' },
      { name: 'Sprint Review', frequency: 'Bi-weekly', duration: '1 hour', role: 'Demo features' },
      { name: 'Retrospective', frequency: 'Bi-weekly', duration: '1 hour', role: 'Share feedback' }
    ]
  },
  mid: {
    processes: [
      { name: 'Architecture Review', description: 'Review and approve system design changes', frequency: 'Weekly' },
      { name: 'Performance Monitoring', description: 'Monitor system performance and optimize', responsibility: 'Own performance metrics' },
      { name: 'Mentorship', description: 'Guide junior developers', commitment: '3-5 hours per week' }
    ],
    responsibilities: [
      { area: 'System Design', tasks: ['Design scalable solutions', 'Review architecture proposals', 'Lead technical discussions'] },
      { area: 'Team Leadership', tasks: ['Mentor junior developers', 'Lead code reviews', 'Technical decision making'] },
      { area: 'Operations', tasks: ['Monitor system health', 'Respond to incidents', 'Optimize performance'] }
    ],
    ceremonies: [
      { name: 'Architecture Review', frequency: 'Weekly', duration: '1 hour', role: 'Reviewer/Presenter' },
      { name: 'Tech Debt Planning', frequency: 'Monthly', duration: '2 hours', role: 'Lead discussion' },
      { name: 'On-call Rotation', frequency: 'Weekly shifts', duration: '24/7', role: 'Primary responder' }
    ]
  },
  senior: {
    processes: [
      { name: 'Strategic Planning', description: 'Define technical roadmap and architecture', scope: 'Cross-team coordination' },
      { name: 'Incident Management', description: 'Lead major incident response', availability: '24/7 escalation point' },
      { name: 'Technology Evaluation', description: 'Research and evaluate new technologies', impact: 'Company-wide decisions' }
    ],
    responsibilities: [
      { area: 'Technical Leadership', tasks: ['Set technical direction', 'Make architectural decisions', 'Drive technical standards'] },
      { area: 'Cross-team Collaboration', tasks: ['Coordinate with other teams', 'Align technical strategies', 'Resolve technical conflicts'] },
      { area: 'Strategic Planning', tasks: ['Define technical roadmap', 'Evaluate new technologies', 'Plan capacity and scaling'] }
    ],
    ceremonies: [
      { name: 'Engineering Leadership', frequency: 'Weekly', duration: '2 hours', role: 'Technical lead' },
      { name: 'Architecture Board', frequency: 'Monthly', duration: '3 hours', role: 'Board member' },
      { name: 'Incident Review', frequency: 'As needed', duration: '2 hours', role: 'Lead reviewer' }
    ]
  }
};
